import React from "react";
import { bool } from "prop-types";

import { onComparablesReportsClick } from "../../../utilities";
import { RESOURCES_TITLE } from "../constants";
import {
  ItemText,
  ListTitle,
  MenuList,
  MultiLevelMenu
} from "../MultiLevelMenu";

const MyActivity = ({ has_comparables, signed_in }) => (
  <MultiLevelMenu title={RESOURCES_TITLE}>
    <ListTitle>Browse</ListTitle>
    <MenuList isSubMenu>
      <li>
        <ItemText href="/blog">StreetEasy Blog</ItemText>
      </li>
    </MenuList>
    <ListTitle>Guides</ListTitle>
    <MenuList isSubMenu>
      <li>
        <ItemText href="/guides/">NYC Real Estate Guides</ItemText>
      </li>
      <li>
        <ItemText href="/neighborhoods">Neighborhood Guides</ItemText>
      </li>
      <li>
        <ItemText href="/guides/moving-nyc/">Moving to NYC Guide</ItemText>
      </li>
    </MenuList>
    <ListTitle>Tools</ListTitle>
    <MenuList isSubMenu>
      <li>
        <ItemText href="/blog/market-reports">Market Reports</ItemText>
      </li>
      {has_comparables && signed_in ? (
        <li>
          <ItemText href="/my/comparables">Comparables Reports</ItemText>
        </li>
      ) : null}
      {has_comparables && !signed_in ? (
        <li>
          <ItemText
            data-gtm-login-required="true"
            data-gtm-origin="comparables_report"
            data-gtm-rendered-from="site_nav"
            data-modal-class="modal-signin"
            href="#"
            onClick={onComparablesReportsClick}
          >
            Comparables Reports
          </ItemText>
        </li>
      ) : null}
      <li>
        <ItemText href="/talk">StreetEasy Forums</ItemText>
      </li>
      <li>
        <ItemText href="/blog/industry-hub">Industry Hub</ItemText>
      </li>
      <li>
        <ItemText href="https://streeteasy.com/blog/data-dashboard/">
          Data Dashboard
        </ItemText>
      </li>
    </MenuList>
  </MultiLevelMenu>
);

MyActivity.propTypes = {
  has_comparables: bool,
  signed_in: bool
};

MyActivity.defaultProps = {
  has_comparables: false,
  signed_in: false
};

export default MyActivity;
